module.exports = __webpack_public_path__ + "img/59.a19a60dc.jpg";